"use client";
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { useNewsletterSubscribe } from '@/hooks/useNewsletterSubscribe';

// Client island: the only interactive part of the footer.
export function FooterNewsletter() {
  const [footerEmail, setFooterEmail] = useState('');
  const [footerSubscribed, setFooterSubscribed] = useState(false);
  const { subscribe: footerSubscribe, isLoading: footerLoading } = useNewsletterSubscribe({
    source: 'footer',
    onSuccess: () => {
      setFooterSubscribed(true);
      setFooterEmail('');
      setTimeout(() => setFooterSubscribed(false), 3000);
    },
  });

  return (
    <form
      onSubmit={async (e) => {
        e.preventDefault();
        await footerSubscribe(footerEmail);
      }}
      className="flex flex-col sm:flex-row gap-3 mb-4"
    >
      <input
        type="email"
        placeholder="Enter your email address"
        value={footerEmail}
        onChange={(e) => setFooterEmail(e.target.value)}
        disabled={footerLoading || footerSubscribed}
        className="flex-1 px-4 py-3 rounded-lg border border-border/50 bg-background/50 backdrop-blur-sm text-sm focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary/50 transition-all"
        required
      />
      <Button type="submit" className="px-6 py-3 shadow-sm" disabled={footerLoading || footerSubscribed}>
        {footerLoading ? 'Subscribing...' : footerSubscribed ? '✓ Subscribed!' : 'Subscribe'}
      </Button>
    </form>
  );
}
